import UserDataForm from "../../components/User/UserDataForm";

export default function UserDataUpdate() {
  return (
      <UserDataForm />
  );
}
